module.exports = function (ary, item) {
  var i = -1, indexes = []
  while((i = ary.indexOf(item, i + 1)) !== -1)
    indexes.push(i)
  return indexes
}



/*****************
 ** WEBPACK FOOTER
 ** ./~/indexes-of/index.js
 ** module id = 100
 ** module chunks = 0
 **/